// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"323":"User","392":"Report","530":"Users","841":"Events","987":"SendList"}[chunkId] || chunkId) + "." + {"141":"8a87282e","323":"5c094a66","392":"172a341e","530":"8114d2e4","787":"ac196e02","841":"65136871","987":"88159427"}[chunkId] + ".chunk.js";
};